import React from "react";

const Bar = () => {
	return (
		<svg width={31} height={30} viewBox="0 0 31 30" fill="none">
			<g clipPath="url(#clip0_3_218)">
				<path
					d="M22.8193 22.5V25H7.81934V22.5H22.8193ZM26.5693 13.75V16.25H4.06934V13.75H26.5693ZM22.8193 5V7.5H7.81934V5H22.8193Z"
					fill="#fff"
				/>
			</g>
			<defs>
				<clipPath id="clip0_3_218">
					<rect
						width={30}
						height={30}
						fill="#fff"
						transform="translate(0.319336)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default Bar;
